import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppParameter from "../components/AppParameter";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="App Parameter" />

        {/* UsersListLayer */}
        <AppParameter />


    </>
  );
};

export default UsersListPage; 
